export function useWordCarousel(connectedWords: string) {
  const words = connectedWords.split(',');

  const firstTime = ref(true);
  const currentIndex = ref(0);
  const wasVisibleIndex = ref(-1);

  const currentWord = computed(() => {
    return words[currentIndex.value];
  });

  return { words, currentWord, startAnimation, wasVisibleIndex };

  function startAnimation() {
    // Initial call with immediate execution
    nextWord(250);

    function nextWord(delay = 2500) {
      setTimeout(() => {
        wasVisibleIndex.value = currentIndex.value;
        currentIndex.value = currentIndex.value + 1;

        if (currentIndex.value === words.length) {
          currentIndex.value = 0;
        }

        // After first execution, always use 2500ms
        nextWord();
      }, delay);
    }
  }
}
